import { useCallback } from 'react'

import { useLocalStorage } from '../../hooks/useLocalStorage'

export const useExpandedPaths = (allPaths: string[], id: string) => {
  const [expandedPaths, setExpandedPaths] = useLocalStorage<string[]>(
    `expandedPaths@${id}`,
  )

  const handleExpandAllPaths = useCallback(() => {
    setExpandedPaths(allPaths)
  }, [allPaths, setExpandedPaths])

  const handleCollapseAllPaths = useCallback(() => {
    setExpandedPaths([])
  }, [setExpandedPaths])

  const handleTogglePath = useCallback(
    (path: string) => {
      const nextOpenPaths = [...(expandedPaths ?? [])]
      const nextStateIndex = nextOpenPaths.findIndex(
        (comparePath) => comparePath === path,
      )

      if (nextStateIndex === -1) {
        nextOpenPaths.push(path)
      } else {
        nextOpenPaths.splice(nextStateIndex, 1)
      }
      setExpandedPaths(nextOpenPaths)
    },
    [expandedPaths, setExpandedPaths],
  )

  return {
    expandedPaths,
    expandAll: handleExpandAllPaths,
    collapseAll: handleCollapseAllPaths,
    togglePath: handleTogglePath,
  }
}
